import { render, staticRenderFns } from "./Mailview.vue?vue&type=template&id=d180defa&"
import script from "./Mailview.vue?vue&type=script&lang=js&"
export * from "./Mailview.vue?vue&type=script&lang=js&"
import style0 from "./Mailview.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports